import React, {FC} from 'react';
import {useDispatch} from 'react-redux';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrashAlt} from '@fortawesome/pro-solid-svg-icons/faTrashAlt';

import {CommonWorktag} from '~/types/common-worktag-type';
import {Button} from 'reactstrap';
import {actions} from "~/state/reducers/worktag-reducer.ts";

interface ComponentProps {
    worktag: CommonWorktag;
    setCommonWorktagsDirty: (dirty: boolean) => void;
}

export const CommonWorktagActionButton: FC<ComponentProps> = ({
  worktag,
  setCommonWorktagsDirty,
}: ComponentProps) => {
    const dispatch = useDispatch();

    const toggleWorktagDeletion = (worktag: CommonWorktag) => {
        if (worktag.toDelete) {
            dispatch(actions.undeleteCommonWorktag(worktag.key));
        } else {
            setCommonWorktagsDirty(true);
            dispatch(actions.deleteCommonWorktag(worktag.key));
        }
    };

  return (
    <div style={{ textAlign: "right" }}>
      <div className="delete-label-container">
        {worktag.toDelete && (
          <small className="pr-3 text-muted">To be deleted</small>
        )}
      </div>
      <Button
        outline={!worktag.toDelete}
        color={worktag.toDelete ? "danger" : "secondary"}
        disabled={worktag.required}
        onClick={() => toggleWorktagDeletion(worktag)}
      >
        <span className="sr-only">Delete common worktag</span>
        <FontAwesomeIcon icon={faTrashAlt} />
      </Button>
    </div>
  );
};

export default CommonWorktagActionButton;
